<script setup>
import dayjs from 'dayjs'
import { getI18n } from '@/plugins/i18n'
import { useWebSiteStore } from '@/stores/web-site.store'
import { usePlanningStore } from '@/stores/planning.store'

import InfoBox from '@/components/shared/InfoBox.vue'
import InputDateSelector from '@/components/shared/InputDateSelector.vue'
import WarehouseSelector from '@/components/shared/WarehouseSelector.vue'

defineProps({
  mobile: {
    type: Boolean,
    default: false,
  },
})

const ordered = defineModel('ordered', { type: Boolean, default: false })
const orderWarehouse = defineModel('orderWarehouse', { type: Number, default: null })
const expectedArrivalDate = defineModel('expectedArrivalDate', { type: String, default: null })

const i18n = getI18n()
const webSiteStore = useWebSiteStore()
const planningStore = usePlanningStore()

const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD')

const onOrderedUpdate = (value) => {
  orderWarehouse.value = value ? orderWarehouse.value ?? webSiteStore.getDefaultOrdersWarehouse() : null
  if (!value) {
    expectedArrivalDate.value = null
  }
}
</script>

<template>
  <div>
    <div class="row items-center no-wrap">
      <q-toggle
        v-model="ordered"
        :label="i18n.t('common.orderedNotDelivered')"
        color="primary"
        @update:model-value="onOrderedUpdate"
      />
      <info-box popup class="q-ml-xs" :message="i18n.t('common.orderWarehouseHint')" />
    </div>
    <div v-if="ordered" class="row q-col-gutter-sm">
      <warehouse-selector
        v-model="orderWarehouse"
        :class="mobile ? 'col-12' : 'col-6'"
        :label="i18n.t('common.orderWarehouse')"
        :kind="planningStore.warehouseKindEnum.VIRTUAL"
        required
      />
      <input-date-selector
        v-model="expectedArrivalDate"
        :class="mobile ? 'col-12' : 'col-6'"
        :range="false"
        :min="tomorrow"
        :label="i18n.t('common.destinationScheduledAt')"
        :rules="[
          val => !!val || i18n.t('common.required'),
          val => dayjs(val).isAfter(dayjs(), 'day') || i18n.t('validation.dateNotInFuture'),
        ]"
      />
    </div>
  </div>
</template>
